import { useContext, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { StatusLabel } from '@shared/components';
import { ToastContext } from '@shared/contexts';
import { DocumentProvider } from '../../documents/contexts/DocumentContext.context';
import { useBlockCtrlS } from '@shared/hooks';
import { useReplica } from '../api';
import { TUseFileResult, FileContainer } from '@modules/files';
import { TUseDocumentResult } from '../../documents/types';
import { getMasterFromData } from '../types';
import { TERMINOLOGY } from '@shared/i18n';

const Replica = () => {
  const { id } = useParams(); // Access the dynamic part of the route
  const { error, data } = useReplica(id as string); // id is always filled, otherwise NoPage.tsx is rendered
  const { show } = useContext(ToastContext);
  const shownArchivedToast = useRef(false);

  useBlockCtrlS();

  useEffect(() => {
    if (!data || shownArchivedToast.current) return;
    if (getMasterFromData(data.masterData).archived) {
      show('warning', `The ${TERMINOLOGY.master.lower} has been archived.`);
      shownArchivedToast.current = true;
    }
  }, [data]);

  return (
    <StatusLabel
      data={data}
      loadingMessage={`Loading ${TERMINOLOGY.replica.lower}...`}
      error={error}
      errorMessage={`Loading ${TERMINOLOGY.replica.lower} failed!`}
      render={(data) =>
        data.replica.type === 'REPLICA_DOCUMENT' ? (
          <DocumentProvider {...(data.masterData as TUseDocumentResult)} replica={data.replica} />
        ) : (
          <FileContainer {...(data.masterData as TUseFileResult)} replica={data.replica} />
        )
      }
    />
  );
};

export default Replica;
